import * as productsTypes from '../types/Products';
import {HIDE_MODAL} from '../types/Modal';
import * as complaintPositionsTypes from '../types/ComplaintPositions';
import * as pageTypes from '../types/Page';

const INITIAL_STATE = { 
    products: [],
    searchProductsPending: false,
    selectedRow: null,
    tablePage: 1,
    textForSearching: '',
    isRowSelected: false
};

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case complaintPositionsTypes.COMPLAINT_POSITIONS_ADD_COMPLAINT_POSITION:
            return INITIAL_STATE;
        case productsTypes.PRODUCT_CHANGE_SELECTED_ROW:
            return{
                ...state,
                selectedRow: action.payload,
                isRowSelected:true
            };
        case productsTypes.PRODUCT_CHANGE_TABLE_PAGE:
            return{
                ...state,
                tablePage: action.payload
            };   
        case productsTypes.PRODUCT_CHANGE_TEXT_FOR_SEARCHING:
            return {
                ...state,
                textForSearching: action.payload
            };
        case productsTypes.PRODUCT_SEARCH_PRODUCTS_BY_TEXT_FAILURE:
            return { 
                ...state, 
                isLoading: false,
            };
        case productsTypes.PRODUCT_SEARCH_PRODUCTS_BY_TEXT_REQUEST:
            return { 
                ...state, 
                products: [],
                isLoading: true,
                isRowSelected:false
            };
        case productsTypes.PRODUCT_SEARCH_PRODUCTS_BY_TEXT_SUCCESS:
            return { 
                ...state, 
                products: action.payload,
                isLoading:false,
            };
        case HIDE_MODAL:
        case productsTypes.PRODUCT_SET_TO_INITIAL_STATE:
            return INITIAL_STATE;
        case pageTypes.PAGE_GO_TO_COMPLAINT_PREVIEW_PAGE:
        case pageTypes.PAGE_GO_TO_START_PAGE: 
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE:
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE_WITHOUT_CUSTOMER_DATA_CLEAR:
            return INITIAL_STATE;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/Products.js